import React from 'react';
import { ResolutionReadView } from '@atlassian/jira-issue-field-resolution/src/ui/read';

type Props = { resolution: { name: string; id: string } | null };

export const ResolutionRead = ({ resolution }: Props) => (
	<ResolutionReadView value={resolution} isLabelClickEnabled hideIcon />
);
